import React from "react";

// Blue Green Studio wordmark — Cormorant Garamond, palette from logo (teal + forest).
export const Wordmark = ({ size = "md", invert = false, className = "" }) => {
  const scale = size === "lg" ? "text-4xl md:text-5xl" : "text-2xl md:text-3xl";
  const studioColor = invert ? "text-sand/80" : "text-stone";

  return (
    <span className={`font-serif tracking-tight leading-none ${scale} ${className}`}>
      <span className="text-teal">Blue</span>
      <span className="text-forest">&nbsp;Green</span>
      <span className={`italic ${studioColor}`}> Studio</span>
    </span>
  );
};
